import { defineMessages } from 'react-intl';

export default defineMessages({
  modalTitle: {
    defaultMessage: 'Ship From Address',
    description: 'title of a section that will display the address to which the order should be shipped',
    id: 'aEwEzV',
  },
  saveButton: {
    defaultMessage: 'Save',
    description: 'text for a button that saves the users changes',
    id: 'qjBa1x',
  },
  verificationBannerErrorMessage: {
    defaultMessage: 'Address validation failed. {verificationMessage}',
    id: 'YkAjBz',
    description: 'text to inform the user that the validation has failed accompanied by the reason which it failed.',
  },
});
